import ReviewRequestMessage from '@console/components/project/ReviewRequestMessage';
import type { AppState } from '@console/reducers';
import { getSelectedProjectDetail } from '@console/selectors/projectDetail';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  selectedProject: getSelectedProjectDetail(state)
});

const mapDispatchToProps = () => ({});

export type ReviewRequestMessagePropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;
export type ReviewRequestMessagePropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewRequestMessage);
